import React from 'react';

export const MISSION_NAME_CORE = 'DRISHTIKON HIMMATWAALI';
export const MISSION_NAME = `${MISSION_NAME_CORE} MISSION`;
export const MISSION_NAME_TITLE_CORE = 'Drishtikon Himmatwaali';
export const MISSION_NAME_TITLE = `${MISSION_NAME_TITLE_CORE} Mission `;

const BrandedMissionName = ({
  variant = 'uppercase',
  className = '',
  gradient = false,
  includeMissionSuffix = true,
}) => {
  const name =
    variant === 'title'
      ? includeMissionSuffix
        ? MISSION_NAME_TITLE
        : MISSION_NAME_TITLE_CORE
      : includeMissionSuffix
        ? MISSION_NAME
        : MISSION_NAME_CORE;

  // const tmMark = (
  //   <sup
  //     className={`mr-1 font-bold not-italic leading-none tracking-tight text-[0.55em] ${
  //       gradient ? 'text-primary' : ''
  //     }`}
  //     aria-hidden="true"
  //   >
  //     {"\u2122"}
  //   </sup>
  // );

  const nameClass = gradient
    ? 'bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent'
    : '';

  return (
    <>
    <span className={`inline max-w-full ${className}`.trim()}>
      
      <span className={nameClass}>{name}</span>
      {"\u2122"}
    </span>
    
    </>
  );
};

export default BrandedMissionName;
